import { defaultRetryDelay } from '../request/util';
import type { RetryOptions } from '../types';

export const DEFAULT_RETRY_OPTIONS = {
  retryDelay: defaultRetryDelay,
  maxRetries: 3,
} as const satisfies RetryOptions;
